import React, { FunctionComponent } from 'react';
import { BsThreeDots } from 'react-icons/bs';
import { MdCheckCircleOutline } from 'react-icons/md';
import { connect } from 'react-redux';
import { Loader } from 'semantic-ui-react';
import { Dropdown, MenuItem, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Origin } from '@upstart/harmony/lib/constants';
import { Checkbox } from '../../Inputs/Checkbox';

interface Action {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

interface Props {
  offerId: string;
  sent: boolean;
  selected: boolean;
  onSelectedChange: (input: boolean) => void;
  actions?: Action[];
  messagingOrigin?: Origin | null;
  offerPymtCalcInProgMap: {
    [key: string]: number;
  };
}

const SelectRow: FunctionComponent<Props> = ({
  offerId,
  sent,
  selected,
  onSelectedChange,
  actions = [],
  messagingOrigin = Origin.INSTORE,
  offerPymtCalcInProgMap,
}) => {
  const checkboxLabel =
    messagingOrigin === Origin.INSTORE
      ? 'Select to Send to Salesperson'
      : 'Select to update deal';
  const sentMessage =
    messagingOrigin === Origin.INSTORE
      ? 'Offer sent to salesperson'
      : 'Deal updated';

  const isDeskingOfferPaymentInProgress = () =>
    (offerPymtCalcInProgMap?.[offerId] || 0) > 0;

  return (
    <div className="select-row">
      <div className="send-to-salesperson">
        <Checkbox
          id={`offer-selected-${offerId}`}
          label={checkboxLabel}
          checked={selected}
          onChange={newValue => onSelectedChange?.(newValue)}
        />
        {sent && (
          <OverlayTrigger
            placement="bottom"
            overlay={
              <Tooltip id="offer-sent-to-salesperson" positionLeft={250}>
                {sentMessage}
              </Tooltip>
            }
          >
            <MdCheckCircleOutline className="sent-icon" />
          </OverlayTrigger>
        )}
      </div>
      {!isDeskingOfferPaymentInProgress() && actions.length > 0 && (
        <Dropdown className="dropdown" id="offer-dropdown-actions" pullRight>
          <Dropdown.Toggle className="dropdown-label" noCaret>
            <BsThreeDots className="menu-icon" />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {actions.map(({ label, onClick, disabled }, i) => (
              <MenuItem key={label} onSelect={onClick} disabled={!!disabled}>
                {label}
              </MenuItem>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      )}
      {isDeskingOfferPaymentInProgress() && (
        <span
          data-tooltip="The desking offer being updated.."
          data-position="bottom center"
        >
          <Loader size="small" active inline />
        </span>
      )}
    </div>
  );
};

const mapStateToProps = ({ deskingPayments }: any) => ({
  offerPymtCalcInProgMap: deskingPayments.paymentCalcInProgress,
});

export default connect(mapStateToProps)(SelectRow);
